import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=cd5ae0f0&scoped=true"
import script from "./ListaClientes.vue?vue&type=script&lang=js"
export * from "./ListaClientes.vue?vue&type=script&lang=js"
import style0 from "./ListaClientes.vue?vue&type=style&index=0&id=cd5ae0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5ae0f0",
  null
  
)

export default component.exports